<template>
	<div class="spread-user" :style="{ '--height': height, }">
		<div class="index-view-top">
			<van-icon name="arrow-left" size="28" color="#ffffff" @click="refund" />
			<div class="title">{{ $t("head.performance") }}</div>
			<van-icon name="ellipsis" size="28" color="#ffffff" style="opacity: 0;" />
		</div>
		<div class="spread-scroll">
			<div class="performance-details">
				<div class="details">
					<div class="details-top">{{ $t("performance.total") }}：</div>
					<div class="details-bottom">
						<p>${{ awardInfolist.todayTotalPerform }}</p>
						<div @click="myteam">
							<p>{{ $t("performance.performance") }}</p>
						</div>
					</div>
				</div>
			</div>
			<div class="people-number">
				<div class="number">
					<div>
						<p>{{ $t("performance.directCount") }}：</p>
						<p>{{ awardInfolist.directCount }}</p>
					</div>
					<div>
						<p>{{ $t("performance.todayTotalPerformByDirect") }}：</p>
						<p>${{ awardInfolist.todayTotalPerformByDirect }}</p>
					</div>
				</div>
				<div class="number">
					<div>
						<p>{{ $t("performance.other") }}：</p>
						<p>{{ awardInfolist.teamCount }}</p>
					</div>
					<div>
						<p>{{ $t("performance.todayTotalPerformByOther") }}：</p>
						<p>${{ awardInfolist.todayTotalPerformByOther }}</p>
					</div>
				</div>
			</div>
			<div class="my-group">
				<div class="group-coin">
					<div>
						<p :class="type == 'USDT' ? 'coin-active' : ''" @click="type = 'USDT'">USDT</p>
						<p :class="type == 'TRX' ? 'coin-active' : ''" @click="type = 'TRX'">TRX</p>
					</div>
					<p @click="$router.push('/withdrawal')">{{ $t("performance.Commission_withdrawal") }}</p>
				</div>
				<div v-for="item in awardInfolist.awardList">
					<div v-if="type == item.coin">
						<div class="group-title-number">
							<p style="flex: 3">{{ $t("performance.historyAward") }}：</p>
							<div style="flex: 2">
								<p>{{ item.historyAward }}</p>
							</div>
							<p style="flex: 2">{{ $t("performance.yesterdayAward") }}：</p>
							<div style="flex: 2">
								<p>{{ item.yesterdayAward }}</p>
							</div>
						</div>
						<div class="group-title-number">
							<p style="flex: 3">{{ $t("performance.currentAward") }}：</p>
							<div style="flex: 2">
								<p>{{ item.currentAward }}</p>
							</div>
							<p style="flex: 2">{{ $t("performance.todayAward") }}：</p>
							<div style="flex: 2">
								<p>{{ item.todayAward }}</p>
							</div>
						</div>
					</div>

				</div>
			</div>
			<div class="my-percent">
				<div class="percent-title">{{ $t("performance.Commission_ratio") }}</div>
				<div class="table">
					<div class="table-item-header">
						<div>
							<p>{{ $t("performance.level") }}</p>
						</div>
						<div>
							<p>{{ $t("performance.ratio") }}</p>
						</div>
					</div>
					<div class="table-item" v-for="(item, index) in awardInfolist.rateList" :key="index">
						<div>
							<p v-if="item.type == 1">{{ $t("performance.Directly_under") }}</p>
							<p v-else>{{ $t("performance.first") }}{{ item.type }}{{ $t("performance.levelone") }}</p>
						</div>
						<div>
							<p>{{ item.rate }}%</p>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import {
	awardInfo
} from "@/utils/request";
export default {
	data() {
		return {
			dataPickerShow: false,
			dataPickerRange: "",
			minDate: new Date(2010, 1, 1),
			maxDate: new Date(2050, 12, 31),
			awardInfolist: [],
			type: "USDT",
			height: '',//屏幕高度
		};
	},
	created() {
		let h = document.documentElement.clientHeight || document.body.clientHeight;
		if (h > 0) {
			this.height = h + 'px' //页面高度
		} else {
			this.height = "100vh"
		}
	},
	mounted() {
		this.awardInfo()
	},
	methods: {
		awardInfo() {
			awardInfo().then((res) => {
				if (res.code == "200") {
					this.awardInfolist = res.data
				}
			})
		},
		refund() {
			this.$router.go(-1)
		},
		myteam() {
			this.$router.push("/myteam")
		},
		onConfirm(value) {
			this.dataPickerRange =
				value[0].getFullYear() +
				"-" +
				(value[0].getMonth() + 1) +
				"-" +
				value[0].getDate() +
				"~" +
				value[1].getFullYear() +
				"-" +
				(value[1].getMonth() + 1) +
				"-" +
				value[1].getDate();
			this.dataPickerShow = false;
		},
		toBack() {
			this.$router.push("/user");
		},
	},
};
</script>

<style lang="scss" scoped>
/deep/.my-swipe .van-swipe-item {
	color: #fff;
	font-size: 1.25rem;
	text-align: center;
	background-color: #39a9ed;
}

.van-hairline--top-bottom::after,
.van-hairline-unset--top-bottom::after {
	border: unset;
}

/deep/ .van-field__control {
	color: #ffffff !important;
}

.van-cell {
	background: #161414;
	//border-radius: 1.375rem;
}

.van-cell-group {
	background: #161414;
	border-radius: 1.375rem;
}

.people-number {
	padding: 0.9375rem;

	.number {
		display: flex;
		justify-content: space-between;

		>div {
			display: flex;

			>p:nth-child(1) {
				font-size: 0.8125rem;
				font-family: PingFang SC-Regular, PingFang SC;
				font-weight: 400;
				color: #666666;
			}

			>p:nth-child(2) {
				font-size: 0.8125rem;
				font-family: PingFang SC-Regular, PingFang SC;
				font-weight: 400;
				color: #ffffff;
			}
		}
	}
}

.performance-details {
	padding: 0 0.9375rem;

	.details {
		background: linear-gradient(180deg, #ffdb67 0%, #ffc400 100%);
		border-radius: 0.625rem;
		padding: 1.5rem 0;

		.details-top {
			font-size: 0.6875rem;
			font-family: PingFang SC-Medium, PingFang SC;
			font-weight: 500;
			color: #ffffff;
			padding: 0 1.25rem;
		}

		.details-bottom {
			display: flex;
			justify-content: space-between;

			>p {
				font-size: 1.25rem;
				font-family: PingFang SC-Heavy, PingFang SC;
				font-weight: 800;
				color: #ffffff;
				padding-left: 1.25rem;
			}

			>div {
				width: 4.5rem;
				height: 1.5625rem;
				background: #ffffff;
				border-radius: 0.8125rem 0px 0px 0.8125rem;
				display: flex;
				align-items: center;
				justify-content: center;

				>p {
					font-size: 0.6875rem;
					font-family: PingFang SC-Medium, PingFang SC;
					font-weight: 500;
					color: #ffc400;
				}
			}
		}
	}
}

.spread-user {
	width: 100vw;
	height: var(--height);
	background: #0c0b0b;

	.data-time-picker {
		height: 4rem;
		padding: 0 0.9375rem;

		>div {
			display: flex;
			align-items: center;
			justify-content: space-between;

			.dataPicker {
				width: 50%;

				>p {
					font-size: 0.8125rem;
					font-family: PingFang SC-Medium, PingFang SC;
					font-weight: 500;
					color: #999999;
				}
			}

			>p {
				display: block;
				font-size: 0.8125rem;
				font-family: PingFang SC-Medium, PingFang SC;
				font-weight: 500;
				color: #ffffff;
				height: 1rem;
			}
		}
	}

	.spread-scroll {
		height: calc(var(--height) - 3.75rem);
		width: 100vw;
		overflow-x: hidden;
		overflow-y: scroll;
	}

	.my-percent {
		padding: 0 0.9375rem;

		.percent-title {
			font-size: 1rem;
			font-family: PingFang SC-Medium, PingFang SC;
			font-weight: 500;
			color: #ffffff;
			padding: 0.9375rem;
		}

		.table {
			width: 100%;
			border-radius: 0.625rem;
			border: 0.0625rem solid #272727;

			.table-item-header {
				height: 2.6875rem;
				display: flex;
				background: #161414;
				border-radius: 0.625rem 0.625rem 0px 0px;

				>div {
					flex: 1;
					display: flex;
					align-items: center;
					justify-content: center;

					>p {
						font-size: 0.875rem;
						font-family: PingFang SC-Medium, PingFang SC;
						font-weight: 500;
						color: #ffffff;
					}
				}
			}

			.table-item {
				height: 2.6875rem;
				display: flex;
				background: #0c0b0b;
				border-top: 0.0625rem solid #272727;
				border-radius: 0px 0px 0.625rem 0.625rem;

				>div {
					flex: 1;
					display: flex;
					align-items: center;
					justify-content: center;

					>p {
						font-size: 0.75rem;
						font-family: PingFang SC-Medium, PingFang SC;
						font-weight: 500;
						color: #999999;
					}

					>p:nth-child(2) {
						border-left: 0.0625rem solid #272727;
					}
				}
			}
		}
	}

	.my-invite {
		border-bottom: 0.375rem solid #060505;
		padding: 0 0.9375rem;

		.top-title {
			display: flex;
			align-items: center;
			padding: 0.9375rem;

			>p:nth-child(1) {
				font-size: 1rem;
				font-family: PingFang SC-Medium, PingFang SC;
				font-weight: 500;
				color: #ffffff;
			}

			>p:nth-child(2) {
				font-size: 0.75rem;
				font-family: PingFang SC-Medium, PingFang SC;
				font-weight: 500;
				color: #999999;
				padding-left: 0.9375rem;
			}
		}

		.invite-title {
			font-size: 1rem;
			font-family: PingFang SC-Medium, PingFang SC;
			font-weight: 500;
			color: #ffffff;
			padding: 0.9375rem;
		}

		.invite-code {
			display: flex;
			align-items: center;
			justify-content: space-between;
			padding-bottom: 0.9375rem;

			>div {
				width: 13.375rem;
				height: 2.6875rem;
				background: #161414;
				border-radius: 0.25rem;
				display: flex;
				align-items: center;

				>p {
					font-size: 0.8125rem;
					font-family: PingFang SC-Medium, PingFang SC;
					font-weight: 500;
					color: #999999;
					padding-left: 0.9375rem;
				}
			}
		}
	}

	.my-group {
		border-top: 0.375rem solid #060505;
		border-bottom: 0.375rem solid #060505;
		padding: 0.9375rem;

		.group-coin {
			display: flex;
			align-items: center;
			justify-content: space-between;
			padding-bottom: 1rem;

			>div {
				display: flex;

				.coin-active {
					color: #ffc400 !important;
					border-bottom: 0.0625rem solid #ffc400 !important;
				}

				>p {
					display: block;
					margin-right: 3rem;
					font-size: 0.875rem;
					font-family: PingFang SC-Medium, PingFang SC;
					font-weight: 500;
					color: #999999;
					border-bottom: 0.0625rem solid #0c0b0b;
				}
			}

			>p {
				font-size: 0.75rem;
				font-family: PingFang SC-Medium, PingFang SC;
				font-weight: 500;
				color: #999999;
			}
		}

		.group-title {
			display: flex;
			justify-content: space-between;
			padding: 0.9375rem 0 1.25rem;

			>p:nth-child(1) {
				font-size: 1rem;
				font-family: PingFang SC-Medium, PingFang SC;
				font-weight: 500;
				color: #ffffff;
			}

			>p:nth-child(2) {
				font-size: 0.75rem;
				font-family: PingFang SC-Medium, PingFang SC;
				font-weight: 500;
				color: #999999;
			}
		}

		.group-title-number {
			display: flex;
			align-items: center;
			padding: 0 0 0.9375rem;

			>p {
				display: block;
				flex: 1;
				font-size: 0.75rem;
				font-family: PingFang SC-Medium, PingFang SC;
				font-weight: 500;
				color: #999999;
				text-align: center;
			}

			>div {
				flex: 1;
				height: 2.375rem;
				border-radius: 0.25rem;
				border: 0.0625rem solid #272727;
				display: flex;
				align-items: center;

				>p {
					padding: 0 0.625rem;
					font-size: 0.8125rem;
					font-family: PingFang SC-Medium, PingFang SC;
					font-weight: 500;
					color: #555555;
					white-space: nowrap;
					text-overflow: ellipsis;
					overflow: hidden;
				}
			}
		}
	}

	.invite-link {
		padding: 0.9375rem;

		.link-button {
			padding: 1.25rem 1.875rem 0.9375rem;

			>div {
				height: 2.6875rem;
				border-radius: 1.375rem;
				border: 0.0625rem solid #ffc400;
				display: flex;
				align-items: center;
				justify-content: center;

				>p {
					font-size: 0.9375rem;
					font-family: PingFang SC-Medium, PingFang SC;
					font-weight: 500;
					color: #ffc400;
				}
			}
		}

		.link-card {
			display: flex;
			justify-content: space-around;
			padding: 1.5rem 0.75rem;
			background: #161414;
			border-radius: 0.625rem;

			>div {
				display: flex;
				flex-direction: column;
				justify-content: center;
				align-items: center;

				.dot {
					width: 1.5rem;
					height: 0.325rem;
				}

				.card-image {
					width: 2.25rem;
					height: 2.1875rem;
				}

				>p {
					font-size: 0.75rem;
					font-family: PingFang SC-Medium, PingFang SC;
					font-weight: 500;
					color: #999999;
				}
			}
		}
	}

	.spread-bannner {
		position: relative;

		.bannner-tips {
			position: absolute;
			z-index: 999;
			width: 100%;
			height: 2.1875rem;
			background: rgba(0, 0, 0, 0.3);
			padding: 0 0.9375rem;
			display: flex;
			align-items: center;

			>img {
				width: 1.4375rem;
				height: 1.4375rem;
				background: #ffffff;
				border-radius: 50%;
			}

			>p {
				font-size: 0.6875rem;
				font-family: PingFang SC-Medium, PingFang SC;
				font-weight: 500;
				color: #ffffff;
				padding-left: 0.625rem;
			}
		}

		.my-swipe {
			z-index: 99;
			height: 9.375rem;

			.banner-image {
				width: 100%;
				height: 100%;
			}
		}
	}

	.index-view-top {
		height: 3.625rem;
		padding: 0 0.9375rem;
		display: flex;
		align-items: center;
		justify-content: space-between;

		.title {
			font-size: 1.125rem;
			font-family: PingFang SC-Bold, PingFang SC;
			font-weight: bold;
			color: #ffffff;
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/spread/performance.vue